<template>
  <div class="form-field">
    <div class="form-label">
      {{label}}
    </div>
    <div :class="opened?'form-input opened':'form-input'" @click="openClose">
      <div :class="Object.keys(modelValue).length !== 0?'isset':''" >
        {{modelValue?.[title] ?? placeholder}}
      </div>
    </div>
    <div class="form-options" v-show="opened">
      <ul>
        <li
            v-for="(option, index) in options"
            :key="index"
            @click="select(option)"
        >
          {{ option?.[title] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits, ref } from 'vue'
  const opened = ref(false)
  defineProps({
    modelValue: {
      type: Object,
      required: true
    },
    label: String,
    placeholder: {
      type:String,
      default: 'Выберите из списка'
    },
    options: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default:'title'
    }
  })

  const emit = defineEmits(['update:modelValue'])
  function select(option) {
    emit('update:modelValue', option)
  }
  function openClose() {
    if (opened.value === false) {
      opened.value = true;
        setTimeout(() => {
          document.body.addEventListener('click', openClose);
        }, 100);
    } else {
      document.body.removeEventListener('click', openClose);
      opened.value = false;
    }
  }
</script>

<style scoped>
.form-input {
  cursor: pointer;
}
</style>